<template>
  <div class="min-h-screen px-6 py-8 md:px-10">
    <div class="w-full space-y-6">
      <div class="flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between">
        <div>
          <h1 class="mt-2 text-3xl text-gray-900">
            {{ isEdit ? "Editar mensagem proibida" : "Nova mensagem proibida" }}
          </h1>
          <p class="mt-2 max-w-2xl text-sm text-gray-500">Defina o conteúdo que deve ser bloqueado antes do envio para garantir conformidade no atendimento.</p>
        </div>

        <div class="flex flex-col gap-3 sm:flex-row">
          <button
            type="button"
            class="icon-anim-trigger--back group flex h-11 items-center justify-center gap-2 rounded-xl border border-gray-200 bg-white px-5 font-medium text-gray-700 shadow-sm transition-all duration-200 hover:-translate-y-0.5 hover:border-gray-300 hover:bg-gray-50 hover:shadow-md"
            @click="voltar"
          >
            <svg class="icon-anim icon-anim--back h-5 w-5 text-gray-500 group-hover:text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
            </svg>
            Voltar
          </button>
        </div>
      </div>

      <form class="space-y-6" @submit.prevent="salvar" autocomplete="off">
        <div class="overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-sm">
          <div class="border-b border-gray-100 px-6 py-5">
            <h2 class="text-lg font-semibold text-gray-900">Conteudo bloqueado</h2>
            <p class="mt-1 max-w-2xl text-sm text-gray-500">Cadastre a palavra ou frase que deve ser impedida no momento do envio.</p>
          </div>

          <div class="p-6">
            <div class="grid grid-cols-1 gap-4 md:grid-cols-12">
              <div class="flex flex-col gap-1 md:col-span-12">
                <label class="text-sm font-medium text-gray-500">Frase / Palavra</label>
                <input
                  v-model="form.frase"
                  type="text"
                  placeholder="Ex.: boleto vencido"
                  required
                  class="h-11 rounded-xl border border-gray-200 bg-white px-4 text-gray-700 outline-none transition focus:border-blue-300 focus:ring-2 focus:ring-blue-100"
                />
              </div>

              <div class="flex flex-col gap-1 md:col-span-4">
                <label class="text-sm font-medium text-gray-500">Categoria</label>
                <div class="relative group">
                  <select
                    v-model="form.categoria"
                    class="h-11 w-full cursor-pointer appearance-none rounded-xl border border-gray-200 bg-white px-4 pr-10 text-gray-700 outline-none transition-all duration-200 focus:border-blue-300 focus:ring-2 focus:ring-blue-100"
                  >
                    <option value="geral">Geral</option>
                    <option value="atendimento">Atendimento</option>
                    <option value="financeiro">Financeiro</option>
                    <option value="operacional">Operacional</option>
                  </select>
                  <svg class="select-icon h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                  </svg>
                </div>
              </div>

              <div class="flex flex-col gap-1 md:col-span-8">
                <label class="text-sm font-medium text-gray-500">Observacao</label>
                <input
                  v-model="form.observacao"
                  type="text"
                  placeholder="Contexto opcional para uso interno"
                  class="h-11 rounded-xl border border-gray-200 bg-white px-4 text-gray-700 outline-none transition focus:border-blue-300 focus:ring-2 focus:ring-blue-100"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="flex flex-col-reverse gap-3 sm:flex-row sm:justify-end">
          <button type="button" class="h-11 rounded-xl border border-gray-200 bg-white px-5 font-medium text-gray-700 transition hover:bg-gray-50" @click="voltar">Cancelar</button>

          <button type="submit" class="h-11 rounded-xl bg-blue-500 px-6 font-medium text-white transition hover:bg-blue-600">
            {{ isEdit ? "Salvar alterações" : "Salvar mensagem" }}
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      form: {
        frase: "",
        categoria: "geral",
        observacao: ""
      }
    };
  },
  computed: {
    isEdit() {
      return !!this.$route.params.id;
    }
  },
  methods: {
    voltar() {
      this.$router.push({ path: "/operadores/msgproibida" });
    },
    async carregar() {
      if (!this.isEdit) return;

      const resp = await this.$http.get(`/v1/operador/msgproibida/${this.$route.params.id}`);
      if (!resp.data.success) {
        this.$vToastify.error(resp.data.err || "Registro não encontrado");
        this.voltar();
        return;
      }

      this.form.frase = resp.data.data.frase || "";
      this.form.categoria = resp.data.data.categoria || "geral";
      this.form.observacao = resp.data.data.observacao || "";
    },
    async salvar() {
      if (this.loading) return;
      if (!this.form.frase || !this.form.frase.trim()) {
        this.$vToastify.error("Digite a frase / palavra");
        return;
      }

      this.loading = true;
      try {
        let resp;
        if (this.isEdit) {
          resp = await this.$http.put(`/v1/operador/msgproibida/${this.$route.params.id}`, this.form);
        } else {
          resp = await this.$http.post("/v1/operador/msgproibida", this.form);
        }

        if (!resp.data.success) {
          this.$vToastify.error(resp.data.err || "Não foi possível salvar.");
          return;
        }

        this.$vToastify.success(this.isEdit ? "Mensagem atualizada com sucesso!" : "Mensagem cadastrada com sucesso!");
        this.voltar();
      } finally {
        this.loading = false;
      }
    }
  },
  async beforeMount() {
    this.carregar();
  }
};
</script>

<style scoped>
.select-icon {
  position: absolute;
  right: 0.75rem;
  top: 50%;
  pointer-events: none;
  color: #9ca3af;
  transform: translateY(-50%);
  transition: transform 0.2s ease, color 0.2s ease;
}

.group:focus-within .select-icon {
  color: #2563eb;
  transform: translateY(-50%) rotate(180deg);
}
</style>
